import api from './api';

export interface Supplier {
  id: number;
  name: string;
  code: string;
  address: string | null;
  phone: string | null;
  email: string | null;
  contact_person: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateSupplierData {
  name: string;
  code: string;
  address?: string;
  phone?: string;
  email?: string;
  contact_person?: string;
}

export interface UpdateSupplierData {
  name: string;
  address?: string;
  phone?: string;
  email?: string;
  contact_person?: string;
}

export const supplierService = {
  // Lấy danh sách nhà cung cấp
  getSuppliers: async (): Promise<Supplier[]> => {
    const response = await api.get('/api/suppliers');
    return response.data.data;
  },

  // Lấy nhà cung cấp theo ID
  getSupplier: async (id: number): Promise<Supplier> => {
    const response = await api.get(`/api/suppliers/${id}`);
    return response.data.data;
  },

  // Tạo nhà cung cấp mới
  createSupplier: async (data: CreateSupplierData): Promise<{ supplierId: number }> => {
    const response = await api.post('/api/suppliers', data);
    return response.data;
  },

  // Cập nhật nhà cung cấp
  updateSupplier: async (id: number, data: UpdateSupplierData): Promise<void> => {
    await api.put(`/api/suppliers/${id}`, data);
  },

  // Xóa nhà cung cấp (soft delete)
  deleteSupplier: async (id: number): Promise<void> => {
    await api.delete(`/api/suppliers/${id}`);
  },

  // Tìm kiếm nhà cung cấp
  searchSuppliers: async (query: string): Promise<Supplier[]> => {
    const response = await api.get(`/api/suppliers/search/${encodeURIComponent(query)}`);
    return response.data.data;
  },
}; 